/* Packshots on the front page's coloured squares (section-hero.liquid, "Animated products"; owner, 2026-10-22).
   Started once the square is in view (on a phone it can start off screen in the rail); never repeats.
   walk: one after another from the right (CSS); each one already standing leans a little as the next arrives, and at
   the end they hop once together, then stand still.
   match: all stand mixed; the ones that do not fit drop away one by one, the three left close up, get a tick and hop.
   With several needs (rounds) the next fades in after a pause, with its need in the pill; it stops on the last.
   Reduced motion or no script: the end state, still (the CSS default). */
(() => {
  // Several sections print this script; the first run takes every square on the page, so later copies stop here.
  if (window.ecHeroWalk) return;
  window.ecHeroWalk = true;
  const walks = document.querySelectorAll("[data-hero-walk]");
  if (!walks.length || !("IntersectionObserver" in window) || !Element.prototype.animate) return;
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const hop = (items, delay) =>
    items.forEach((el, i) =>
      el.animate([{ translate: "0 0" }, { translate: "0 -9%" }, { translate: "0 0" }, { translate: "0 -3%" }, { translate: "0 0" }], { duration: 650, delay: delay + i * 70, easing: "ease-out" })
    );

  const walk = (w) => {
    const items = [...w.querySelectorAll(".hero-rail__walk-item")];
    // When item j has arrived (its CSS walk: 0.2s + j × 0.6s delay, 1.2s long, standing at about 85 %).
    const arrives = (j) => 200 + j * 600 + 1020;
    items.forEach((el, i) => {
      for (let j = i + 1; j < items.length; j++) {
        el.animate([{ rotate: "0deg" }, { rotate: "-6deg" }, { rotate: "2deg" }, { rotate: "0deg" }], { duration: 520, delay: arrives(j), easing: "ease-out" });
      }
    });
    // Its step number pops in as each product lands.
    items.forEach((el, j) => {
      const n = el.querySelector(".hero-rail__walk-tick");
      if (n) n.animate([{ opacity: 0, scale: 0.4 }, { opacity: 1, scale: 1.15 }, { opacity: 1, scale: 1 }], { duration: 360, delay: arrives(j) + 80, easing: "ease-out", fill: "backwards" });
    });
    hop(items, arrives(items.length - 1) + 300);
    w.classList.add("is-walking");
  };

  const match = (w) => {
    const all = [...w.querySelectorAll(".hero-rail__walk-item")];
    const drops = all.filter((el) => el.classList.contains("hero-rail__walk-item--drop"));
    const keep = all.filter((el) => !drops.includes(el));
    // The need first (the pill above), then what does not fit it drops away.
    const concern = w.parentElement.querySelector(".hero-rail__walk-concern");
    if (concern && w.dataset.need) concern.textContent = w.dataset.need;
    if (concern) concern.animate([{ opacity: 0, translate: "0 6px" }, { opacity: 1, translate: "0 0" }], { duration: 400, delay: 300, easing: "ease-out", fill: "backwards" });
    const t = concern ? 1500 : 1200;
    const gone = drops.map((el, k) =>
      el.animate([{ opacity: 1, translate: "0 0" }, { opacity: 0, translate: "0 35%" }], { duration: 420, delay: t + k * 380, easing: "ease-in", fill: "forwards" }).finished
    );
    Promise.all(gone).then(() => {
      // Close up: where each keeper stands now, then where it stands without the others, and slide between (FLIP).
      // They also grow from the five-in-a-row size to the walk-in size (scale from the old width, from the foot).
      const before = keep.map((el) => el.getBoundingClientRect());
      w.classList.add("is-matched");
      keep.forEach((el, i) => {
        const now = el.getBoundingClientRect();
        const k = now.width ? before[i].width / now.width : 1;
        const dx = before[i].left + before[i].width / 2 - (now.left + now.width / 2);
        el.animate(
          [{ translate: dx + "px 0", scale: String(k) }, { translate: "0 0", scale: "1" }],
          { duration: 560, easing: "cubic-bezier(0.25, 0.6, 0.3, 1)" }
        );
      });
      w.querySelectorAll(".hero-rail__walk-tick").forEach((tick, i) =>
        tick.animate([{ opacity: 0, scale: 0.4 }, { opacity: 1, scale: 1.15 }, { opacity: 1, scale: 1 }], { duration: 380, delay: 560 + i * 120, easing: "ease-out", fill: "backwards" })
      );
      const settled = 560 + keep.length * 120 + 200;
      hop(keep, settled);
      // The next need, if any: a pause to read this one, then this round fades out and the next plays.
      const next = w.nextElementSibling && w.nextElementSibling.matches("[data-hero-walk-next]") ? w.nextElementSibling : null;
      if (!next) return;
      setTimeout(() => {
        const out = [w, concern].filter(Boolean).map((el) => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 350, easing: "ease-in", fill: "forwards" }).finished);
        Promise.all(out).then(() => {
          w.hidden = true;
          next.hidden = false;
          next.classList.add("is-ready");
          if (concern) concern.getAnimations().forEach((a) => a.cancel());
          match(next);
        });
      }, settled + 650 + 2200);
    });
  };

  const io = new IntersectionObserver(
    (entries) =>
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        (e.target.dataset.heroWalk === "match" ? match : walk)(e.target);
      }),
    { threshold: 0.6 }
  );
  walks.forEach((w) => {
    w.classList.add("is-ready");
    io.observe(w);
  });
})();
